import CompaniesNotification from './CompaniesNotification';

export default CompaniesNotification;
